// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import {
    MDBCol, MDBRow,
} from 'mdbreact';
import axios from 'axios';
import { datatableManagerFundsColumnsForContractor as columns, localCurrencySettings } from '../../utils/constans';
// eslint-disable-next-line import/no-cycle
import Notification from '../../components/notification';

const ContractorManageFunds = ({ mainContainer }) => {
    const [datatable, setDatatable] = useState([]);

    const getPaymentStatus = (workOrderStatus, paymentStatus) => {
        if (paymentStatus) return paymentStatus.replace(/^\w/, c => c.toUpperCase());
        if (workOrderStatus === 'paid') return 'Direct Payment';
        return 'Pending';
    };

    useEffect(() => {
        axios.get('/api/payment/contractor/history')
            .then(res => (
                setDatatable(res.data.workOrders.map(workOrder => ({
                    ...workOrder,
                    paidAt: new Date(workOrder.approvedAt).toLocaleString('en-US'),
                    clientName: workOrder.clientName,
                    amount: `+${(workOrder.finalPay || 0).toLocaleString('en-US', localCurrencySettings)}`,
                    workOrderNamed: `${workOrder.WIN} - ${workOrder.title}`,
                    status: getPaymentStatus(workOrder.status, workOrder?.payment?.status),
                })) || [])
            ))
            .catch(error => {
                Notification('error', {
                    message: error.response?.data.message || error.message,
                });
            });
    }, []);

    return (
        <div className="subpage-wrap subpage-wrap--contractor-payments">
            <div className="subpage-header">
                <h1 className="subpage-title">Payment History</h1>
            </div>

            <div className="subpage-table-scroll subpage-table-scroll--payments">
                <table className="subpage-table subpage-table--payments">
                    <thead>
                        <tr>
                            {columns.map(col => (
                                <th key={col.field} scope="col">{col.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {datatable.length > 0 ? (
                            datatable.map((row, idx) => (
                                <tr key={idx}>
                                    {columns.map(col => (
                                        <td key={col.field} data-label={col.label}>
                                            {row[col.field]}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr className="subpage-table-empty">
                                <td colSpan={columns.length}>
                                    No payment history yet.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ContractorManageFunds;
